import _defineProperty from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var DEFAULT_RETRY_ATTEMPTS = 3;
/**
 * Retry middleware
 */

var retryMiddlewareFactory = function retryMiddlewareFactory(_ref) {
  var _ref$maxAttempts = _ref.maxAttempts,
      maxAttempts = _ref$maxAttempts === void 0 ? DEFAULT_RETRY_ATTEMPTS : _ref$maxAttempts,
      retryDecider = _ref.retryDecider,
      computeDelay = _ref.computeDelay,
      abortSignal = _ref.abortSignal;

  if (maxAttempts < 1) {
    throw new Error('maxAttempts must be greater than 0');
  }

  return function (next, context) {
    return /*#__PURE__*/function () {
      var _retryMiddleware = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var _context$attemptsCoun;

        var error, attemptsCount, response, handleTerminalErrorOrResponse, _context$attemptsCoun2, _context$attemptsCoun3, delay;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                attemptsCount = (_context$attemptsCoun = context.attemptsCount) !== null && _context$attemptsCoun !== void 0 ? _context$attemptsCoun : 0;

                // When retry is not needed or max attempts is reached, either error or response will be set. This function handles either cases.
                handleTerminalErrorOrResponse = function handleTerminalErrorOrResponse() {
                  if (response) {
                    addOrIncrementMetadataAttempts(response, attemptsCount);
                    return response;
                  } else {
                    addOrIncrementMetadataAttempts(error, attemptsCount);
                    throw error;
                  }
                };

              case 2:
                if (!(!(abortSignal !== null && abortSignal !== void 0 && abortSignal.aborted) && attemptsCount < maxAttempts)) {
                  _context.next = 29;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return next(request);

              case 6:
                response = _context.sent;
                error = undefined;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                error = _context.t0;
                response = undefined;

              case 14:
                // context.attemptsCount may be updated after calling next handler which may retry the request by itself.
                attemptsCount = ((_context$attemptsCoun2 = context.attemptsCount) !== null && _context$attemptsCoun2 !== void 0 ? _context$attemptsCoun2 : 0) > attemptsCount ? (_context$attemptsCoun3 = context.attemptsCount) !== null && _context$attemptsCoun3 !== void 0 ? _context$attemptsCoun3 : 0 : attemptsCount + 1;
                context.attemptsCount = attemptsCount;
                _context.next = 18;
                return retryDecider(response, error);

              case 18:
                if (!_context.sent) {
                  _context.next = 26;
                  break;
                }

                if (!(!(abortSignal !== null && abortSignal !== void 0 && abortSignal.aborted) && attemptsCount < maxAttempts)) {
                  _context.next = 23;
                  break;
                }

                // prevent sleep for last attempt or cancelled request;
                delay = computeDelay(attemptsCount);
                _context.next = 23;
                return cancellableSleep(delay, abortSignal);

              case 23:
                return _context.abrupt("continue", 2);

              case 26:
                return _context.abrupt("return", handleTerminalErrorOrResponse());

              case 27:
                _context.next = 2;
                break;

              case 29:
                if (!(abortSignal !== null && abortSignal !== void 0 && abortSignal.aborted)) {
                  _context.next = 33;
                  break;
                }

                throw new Error('Request aborted.');

              case 33:
                return _context.abrupt("return", handleTerminalErrorOrResponse());

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));

      function retryMiddleware(_x) {
        return _retryMiddleware.apply(this, arguments);
      }

      return retryMiddleware;
    }();
  };
};

var cancellableSleep = function cancellableSleep(timeoutMs, abortSignal) {
  if (abortSignal !== null && abortSignal !== void 0 && abortSignal.aborted) {
    return Promise.resolve();
  }

  var timeoutId;
  var sleepPromiseResolveFn;
  var sleepPromise = new Promise(function (resolve) {
    sleepPromiseResolveFn = resolve;
    timeoutId = setTimeout(resolve, timeoutMs);
  });
  abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.addEventListener('abort', function cancelSleep(_) {
    clearTimeout(timeoutId);
    abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.removeEventListener('abort', cancelSleep);
    sleepPromiseResolveFn();
  });
  return sleepPromise;
};

var addOrIncrementMetadataAttempts = function addOrIncrementMetadataAttempts(nextHandlerOutput, attempts) {
  var _nextHandlerOutput$$m;

  if (Object.prototype.toString.call(nextHandlerOutput) !== '[object Object]') {
    return;
  }

  nextHandlerOutput.$metadata = _objectSpread(_objectSpread({}, (_nextHandlerOutput$$m = nextHandlerOutput.$metadata) !== null && _nextHandlerOutput$$m !== void 0 ? _nextHandlerOutput$$m : {}), {}, {
    attempts: attempts
  });
};

export { retryMiddlewareFactory };